export const linkedinUrlRegex = /linkedin\.com\/(in|pub|profile|mwlite\/in)\/([0-9\w-/%]+)\/?/
